













import Vue from "vue";
import InputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";

export default Vue.extend({
    components: {
        InputNumber: InputNumber
    },
    data: function() {
        return {
            pathInStore: "property.specificities.largeEnterprise.showroomSurface",
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["OFFICE", "INDUSTRY", "COMMERCIAL"].indexOf(this.getPropertyType()) !== - 1;
        },
        floorAreaShowroom: function(): number {
            return Number(this.$store.getters["FormModule/getValue"](this.pathInStore));
        }
    },
    mounted: function() {
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(showRoomSurface: number): void {
            if (showRoomSurface === 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": showRoomSurface});
            }
        }
    },
});
